module.exports = __webpack_public_path__ + "img/866fc7b.jpg";